import React, {useCallback} from "react";
import {
	Modal,
	ModalBackdrop,
	ModalButtons,
	ModalCloseButton,
	ModalText,
	ModalTitle,
	PrimaryButton,
} from "components/Common";
import {IconClose} from "components/Icons";
import {useTranslation} from "react-i18next";
import logoAsset from "assets/images/logos/logoWhite.png";
import styled from "@emotion/styled";
import {useDispatch, useSelector} from "react-redux";
import {getIsThanksForPlayingModalViewed} from "modules/selectors";
import {sendThanksForPlayingViewed} from "modules/actions";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 12px;
	width: 100%;

	img {
		max-height: 120px;
		height: 100%;
		width: auto;
		margin-top: 60px;
	}

	.title {
		margin-top: 24px;
	}
`;

export const ThanksForPlayingModal: React.FC = () => {
	const {t} = useTranslation();
	const dispatch = useDispatch();
	const isOpen = !useSelector(getIsThanksForPlayingModalViewed);

	const closeModal = useCallback(() => {
		dispatch(sendThanksForPlayingViewed());
	}, [dispatch]);

	if (!isOpen) {
		return null;
	}

	return (
		<ModalBackdrop>
			<Modal>
				<ModalCloseButton onClick={closeModal}>
					<IconClose />
				</ModalCloseButton>

				<Wrapper>
					<img src={logoAsset} alt="MLB BTN" />

					<ModalTitle className="title">{t("modal.thanks.title")}</ModalTitle>
					<ModalText>{t("modal.thanks.text")}</ModalText>

					<ModalButtons>
						<PrimaryButton onClick={closeModal}>
							{t("modal.thanks.action")}
						</PrimaryButton>
					</ModalButtons>
				</Wrapper>
			</Modal>
		</ModalBackdrop>
	);
};
